<script>
import appConfig from "@/app.config";
import LeagueDataFieldForm from "@/components/league-data-fields/crud/Form";

export default {
  page: {
    title: "ثبت فیلد جدید",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    LeagueDataFieldForm,
  },
  data() {
    return {
      items: [
        {
          text: "مدیریت فیلدهای اپلیکیشن",
          to: {
            name: "leagues.data-fields",
            params: { id: this.$route.params.id },
          },
        },
        {
          text: "ثبت فیلد جدید",
          active: true,
        },
      ],
      league: null,
      title: "",
    };
  },
  computed: {
    isEditing() {
      return this.id != undefined && this.id != null;
    },

    id() {
      return this.$route.params.id;
    },
  },
  watch: {
    "$route.fullPath": {
      immediate: true, // Immediate option to call watch handler on first mount
      handler() {
        this.resetForm();
      },
    },
  },
  mounted() {
    this.fetchLeague();
  },
  methods: {
    fetchLeague() {
      this.$axios.get(`leagues/${this.$route.params.leagueId}`).then((res) => {
        this.league = res.data;
        this.title = "افزودن فیلد برای لیگ " + this.league.name;
        this.items[0].text = "افزودن فیلد برای لیگ " + this.league.name;
        if (this.isEditing) {
          this.title = "ویرایش برای لیگ " + this.league.name;
          this.items[0].text = "ویرایش فیلد لیگ " + this.league.name;
        }
      });
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <LeagueDataFieldForm
      v-if="league != null"
      :league-id="$route.params.leagueId"
      :id="$route.params.id"
    />
  </Layout>
</template>
